<div class="autosuggest">
    <div class="autosuggest__container">
      <div class="autosuggest__input-holder">
        <span class="autosuggest__ico"></span>
        <app-autosuggest-input
          [searchQuery]="searchQuery"
          [placeholder]="'autoSuggest.Placeholder' | translate"
          (onQuery)='searchByQuery($event)'>
        </app-autosuggest-input>
      </div>
    </div>
  </div>

<div class="container">
  <div class="container__top">
    <app-heading [note]="subTitle">{{ 'searchResult.Title' | translate }}</app-heading>

    <app-alias-question *ngIf="advancedItems" [items]='advancedItems'></app-alias-question>
  </div>

  <app-result-list
    [itemsPerPage]='itemsPerPage'
    [items]='resultItems'
    [currentPage]='currentPage'
    [total]='total'
    (pageChange)='onPageChange($event)'>
  </app-result-list>
</div>
